import { render } from "./IconMan.vue?vue&type=template&id=78497fa4"
import script from "./IconMan.vue?vue&type=script&lang=js"
export * from "./IconMan.vue?vue&type=script&lang=js"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__